<template>
  <v-app id="inspire" class="bg-dark">
    <v-container class="fill-height" style="padding:0; max-width:100%;" fluid>
      <div class="titleFrame"><img :src="logo.url" :alt="logo.alt" :width="logo.size" class="float-left"></div>
      <div class="imageFrame">
        <img src=""/>
      </div>
      <div v-if="!pwdReset" class="loginFrame">
        <v-card class="elevation-6 loginField rounded-xl">
       <div class="loginHeader">
         <h1>
          {{ $t('loginTitle')}}
         </h1>
       </div>
        <v-card-text>
            <v-text-field
              id="username"
              color="secondary"
              v-model="username"
              label="E-Mail"
              name="login"
              hint="E-Mail"
              prepend-icon="mdi-account"
              type="text"
              placeholder="E-Mail Adresse"
              persistent-placeholder
            ></v-text-field>

            <v-text-field
              id="password"
              color="secondary"
              v-model="password"
              @keyup.enter="login"
              label="Passwort"
              name="password"
              prepend-icon="mdi-lock"
              type="password"
              placeholder="Passwort"
              persistent-placeholder
            ></v-text-field>
            <div v-if="error != null" class="container">
              <v-alert
                type="error"
              >{{ error }}</v-alert>
            </div>
        </v-card-text>
        <v-card-actions style="justify-content: center">
          <v-btn color="primary" @click="login" style="width:80%" elevation="0">Login</v-btn>
          
        </v-card-actions>
        <div class="pwdReset">
          <a @click="pwdReset=true">Passwort zurücksetzen</a>
        </div>
        <div class="support">
          <a target="_blank" href="https://support.motiverse.de/">Benötigen Sie Hilfe?</a> 
        </div>
      </v-card>
      <div class="websiteFooter">
        <a target="_blank" href="https://www.motiverse.de/">Besuchen Sie unsere Website <v-icon color="primary">mdi-launch</v-icon></a> 
      </div>
      </div>
      <div v-if="pwdReset" class="loginFrame">
        <v-card class="elevation-6 loginField rounded-xl">
          <div class="float-left pl-4 pt-4 my-4">
            <v-icon small color="primary" class="d-inline">mdi-arrow-left</v-icon>
            <div v-if="pwdReset" class="d-inline">
              <a @click="pwdReset = false; this.error = null">Zurück zum Login</a>
            </div>
          </div>
       <div class="loginHeader">
         <h2 class="mt-14">
           Geben Sie Ihre E-Mail ein:
         </h2>
       </div>
        <v-card-text>
            <v-text-field
              v-if="!showInfo"
              id="username"
              color="secondary"
              v-model="username"
              label="E-Mail"
              name="login"
              prepend-icon="mdi-account"
              type="text"
            ></v-text-field>
<!--             <div v-if="showInfo" class="container">
              Falls ein Account mit dieser E-Mail-Adresse besteht, bekommen Sie einen Link zum Zurücksetzen Ihres Passwortes.
            </div> -->
            <v-alert
              v-if="(showInfo && !error)"
              dense
              text
              type="success"
              style="width: 82%; font-size: 0.8rem;"
            >
              Eine E-Mail mit Link zum Zurücksetzen des Passwortes wurde versendet
            </v-alert>
            <v-alert
              v-if="!showInfo && error"
              dense
              outlined
              type="error"
              style="width: 82%; font-size: 0.8rem;"
            >
              {{error}}
            </v-alert>
          </v-card-text>
        <v-card-actions class="d-flex flex-column pb-10 mb-8" style="justify-content: center">
          <v-btn v-if="!showInfo" elevation="0" color="primary" @click="resetPwd" style="width:80%">Passwort
            zurücksetzen</v-btn>
          <v-btn v-if="showInfo" elevation="0" color="primary" @click="pwdReset = false; this.error = null"
                 style="width:80%">Zurück zum Login</v-btn>
        </v-card-actions>
      </v-card>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import colors from 'vuetify/lib/util/colors'
import loginService from '@/components/loginService'
export default {
  name: "login",

  data() {
    return {
      username: "",
      password: "",
      error: null,
      pwdReset: false,
      showInfo: false,
      logo: {
        url: require('../../assets/motiverse_logo-hor.png'),
        alt: 'logotype',
        size: '16%'
      }
    };
  },
  mounted(){
    this.$vuetify.theme.themes.light.primary = '#FC9861';
    this.$vuetify.theme.themes.light.secondary = '#31307A';
  },
  methods: {
    resetPwd(){
      
      loginService.resetPassword(this.username)
      .then(() => {
        this.error = null; 
        this.showInfo = true;
      })
      .catch(e => this.error="Es existiert kein Nutzer mit dieser E-Mail");
    },
    login() {
      this.errors = [];

      const user = {
        username: this.username,
        password: this.password
      };
      this.$store
        .dispatch("authenticateUser", user)
        .then(() => {
          this.$router.push("/menu");
        })
        .catch((e) => {
          this.error = e.response.data.msg;
        });
    }
  }
};
</script>
<style scoped>
.websiteFooter{
  position: absolute;
  bottom: 25px;
  width:100%;
  text-align-last: center;
  text-align: center;
  color: #353535;
  font-weight: 400;
}
.pwdReset{
  width:100%;
  text-align-last: center;
  text-align: center;
  margin: 10px 0px;
  text-decoration: none;
  font-weight: 600;
}
.support{
  width:100%;
  text-align-last: center;
  text-align: center;
  margin: 25px 0px 0px 0px;
  text-decoration: underline var(--v-primary-base);
  font-size: 0.75rem;
}
.bg-dark{
  background-color: #F9F5F2 !important;
  background-color: #F5F5F5 !important;
}
.loginFrame{
  position: absolute;
  height: 100%;
  left:66%;
  width:36%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loginFrame a {
  font-weight: 600;
}
.imageFrame{
  position: absolute;
  height: 100%;
  width:66%;
  background: url('~@/assets/login_background.jpg') center no-repeat;
  background-size: cover;
  /*box-shadow: inset 2000px 0 0 0 rgba(0, 156, 145, 0.5);*/
}
.imageFrame::before{
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width:100%;
  background-color: rgb(255 255 255 / 83%);
  opacity: 0.4;
}
.loginField{
  overflow: auto;
  height: fit-content;
  width: fit-content;
  min-width: 75%;
  max-width: 80%;
  padding-bottom: 2vh;
}
.titleFrame{
position: absolute;
left: 2.5%;
top: 2.5%;
font-style: normal;
font-weight: 100;
font-size: 2rem;
line-height: 64px;

color: #FFFFFF;
z-index: 1;
}

.loginHeader{
  text-align-last: center;
  padding: 10%;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  /*font-weight: 500;*/
  font-size: 24px;
  line-height: 28px;

  color: #31307A;
}
@media (max-width: 768px) {
  .imageFrame{
    display: none
  }
  .loginFrame{
    left: 0;
    width:100%;
  }
}
:deep .v-form {
  display: flex;
  justify-content: center;
}
:deep .v-alert .v-icon {
  color: #fff;
}
</style>